import { err, ok } from '@xlearn/common';
import { SchemaError, ErrorCode } from '../schema-engine';
import { SuccessStatus, statusToString, parseStatus } from './success-status';

export function getSuccessStatus(status: SuccessStatus) {
  return ok(statusToString(status));
}

export function setSuccessStatus(currentStatus: SuccessStatus, value: string) {
  const parsed = parseStatus(value);
  if (!parsed.success) {
    return err(new SchemaError(ErrorCode.incorrectDataType, value));
  }

  return ok(parsed.value);
}
